export type TypeMaybeArray<T> = T | T[] | null | undefined;

// ----------------------------------------------------------------------------

export function normalizeToArray<T>(input: TypeMaybeArray<T>): T[] {
    if (Array.isArray(input)) {
        return input.filter((v): any => v != null && v !== '');
    }
    if (input != null && input !== '') {
        return [input];
    }
    return [];
}

// ----------------------------------------------------------------------------

export default normalizeToArray;
